module.exports = __webpack_public_path__ + "static/don21-42d353667f5e281e5d2cda32e7ca92a3.jpg";